export function ProgressBar({ porcentaje = 0, color = "bg-white" }) {
  return (
    <div className="w-full bg-gray-200 overflow-hidden rounded-full h-1.5">
      <div
        className={`${color} h-full rounded-full transition-all duration-300´`}
        style={{ width: `${porcentaje}%` }}
      />
    </div>
  );
}
